import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { userService } from './user.service';

const getPlans = currency => {
  const query = { expand: 'product', all: true };
  if (currency) query.currency = currency;
  return axiosInstance
    .get(`/plans`, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401 && !response.config.url.includes('/users/login')) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};

const create = plan => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: plan,
  };

  return axiosInstance
    .post(`/plans`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const update = plan => {
  const planId = plan.planId;
  delete plan.planId;
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: plan,
  };

  return axiosInstance
    .patch(`/plans/${planId}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const getListOfSubscription = currency => {
  const query = { expand: 'product', active: true };
  if (currency) query.currency = currency;
  return axiosInstance
    .get(`/plans`, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

export const planService = {
  getPlans,
  create,
  update,
  getListOfSubscription,
};
